import cn from 'classnames';
import React, { ReactNode } from 'react';

interface StepContentProps {
    children: ReactNode;
    highlighted?: boolean;
    section?: boolean;
}

const StepContent: React.FC<StepContentProps> = ({ children, highlighted = false, section = false }) => {
    const baseClasses = 'text-sm text-brand-neutral-300 leading-relaxed';
    const highlightedClasses = highlighted ? 'border border-brand-neutral-600 rounded-lg p-3 my-2' : '';
    const sectionClasses = section ? 'mt-4 pt-4 border-t border-brand-neutral-700' : '';

    return <div className={cn(baseClasses, highlightedClasses, sectionClasses)}>{children}</div>;
};

export default StepContent;
